<template>
  <div id="ScanVotingPaperDialog_main">
    <el-dialog
      title="請掃描投票單"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="bg" />
      <div class="txt">
        <span>請掃描</span>
        <span class="bold"> 投票單條碼</span>
        <span>，完成住戶投票</span>
      </div>
      <input
        v-model="hideData_account"
        type="text"
        name="user"
      ><!-- 不會使用 -->
      <input
        v-model="hideData_password"
        type="password"
        name="user"
      ><!-- 不會使用 -->
      <input
        id="input_code"
        ref="inputBarcode"
        v-model="barcode"
        type="password"
        autocomplete="off"
        @keyup.enter="sandBarcode"
        @blur="onblur"
      >
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      optionId: '', // 選項id
      optionName: '', // 選項名稱
      hideData_account: '', // 不會使用，騙chrome自動帶入帳號欄位
      hideData_password: '', // 不會使用，騙chrome自動帶入密碼欄位
      barcode: ''
    }
  },
  methods: {
    openDialog (id, optionName) {
      this.dialogVisible = true
      this.optionId = id
      this.optionName = optionName
      this.$nextTick(() => {
        this.$refs.inputBarcode.focus()
      })
    },
    // 送出barcode
    sandBarcode () {
      // eslint-disable-next-line eqeqeq
      if (this.barcode == '') {
        this.$message.error('請掃描投票單')
        return
      }
      const barcode = this.barcode
      this.barcode = ''
      apiUnitOwnerAssembly.Vote.MakeDecision(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId,
          optionId: this.optionId,
          barcode
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$message.success(res.data.tabletName + '，' + this.optionName)
          this.$emit('refresh')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          // eslint-disable-next-line eqeqeq
          if (err.response.data.description.indexOf('已投過票，若要重投請先取消投票') != -1) { this.$message.error('重複投票。') } else if (err.response.data.description.indexOf('不存在或已被刪除，或不在此議案的投票中') != -1) { this.$message.error('投票失敗，此戶別不在報到名單內。') } else { this.$message.error(err.response.data.description) }
        }
      })
    },
    onblur () {
      if (this.dialogVisible) {
        this.$nextTick(() => {
          this.$refs.inputBarcode.focus()
        })
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#ScanVotingPaperDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 680px
    .bg
      height: 156px
      background-size: contain
      background-position: center center
      background-repeat: no-repeat
      margin: 0px auto
      background-image: url('../../../../assets/img/unitOwnerAssembly/scanVote.png')
    .txt
      margin-top: 28px
      line-height: 35px
      font-size: 25px
      color: $mainFontColor
      .bold
        font-weight: bold
    input
      position: absolute
      opacity: 0
      width: 1px
</style>
